/**
 * IdeasList — the gallery of common rules, searchable without AI, with every
 * rule type under "All rule types". Used by "Add a rule" and by "Turn into a
 * rule" on a card the AI couldn't read.
 */
import { useState } from 'react';
import { KIND_META } from './ruleText';

export function IdeasList({ catalogue, onPick }) {
  const [query, setQuery] = useState('');
  const [allTypes, setAllTypes] = useState(false);
  const q = query.trim().toLowerCase();
  const ideas = (catalogue?.ideas || []).filter((i) => !q || i.label.toLowerCase().includes(q) || i.sentence.toLowerCase().includes(q));
  const types = Object.entries(catalogue?.blocks || {}).filter(([k, b]) => k !== 'text' && (!q || b.label.toLowerCase().includes(q) || b.describe.toLowerCase().includes(q)));
  return (
    <div>
      <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search, e.g. power ball"
        className="w-full h-11 px-4 rounded-full border border-[#3AAFA9] text-sm mb-3" />
      {!allTypes ? (
        <ul className="space-y-2">
          {ideas.map((i) => (
            <li key={`${i.block}-${i.label}`}>
              <button onClick={() => onPick({ block: i.block, params: i.params })}
                className="w-full text-left rounded-xl border border-gray-100 p-3 hover:border-[#3AAFA9]" data-testid="idea">
                <p className="font-bold text-sm">{i.label}</p>
                <p className="text-xs text-gray-500">{i.sentence}</p>
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <ul className="space-y-2">
          {types.map(([k, b]) => {
            const kind = KIND_META[b.kind];
            return (
              <li key={k}>
                <button onClick={() => onPick({ block: k, params: {} })}
                  className="w-full text-left rounded-xl border border-gray-100 p-3 hover:border-[#3AAFA9]">
                  <p className="font-bold text-sm flex items-center gap-2">{b.label}
                    <span className="text-[10px] font-semibold px-1.5 rounded" style={{ color: kind.color, background: kind.bg }}>{kind.label}</span></p>
                  <p className="text-xs text-gray-500">{b.describe}</p>
                </button>
              </li>
            );
          })}
        </ul>
      )}
      <button type="button" onClick={() => setAllTypes((v) => !v)} className="mt-3 text-sm font-semibold text-[#1F7A75]"
        data-testid="toggle-all-types">
        {allTypes ? '← Back to ideas' : 'All rule types →'}
      </button>
    </div>
  );
}

export default IdeasList;
